import { GroupsEnum } from "@/enum/groups";
import { RoleEnum } from "@/enum/role";
import CalculationBasisRoutes from "@/pages/tax/calculation-basis/calculation-basis.route";
import TaxClosingRoutes from "@/pages/tax/closing/closing.routes";
import PeriodGateRoutes from "@/pages/tax/closing/period-gate/period-gate.routes";
import ConfigTaxRoutes from "@/pages/tax/config-tax/config-tax";
import { EngineDashboard } from "@/pages/tax/engine-dashboard";
import { EngineHistoryRoutes } from "@/pages/tax/engine-history/engine-history";
import ExceptionTaxRoutes from "@/pages/tax/exception-tax/exception-tax";
import ExtracaoRoutes from "@/pages/tax/extracao-nf-ofm/extracao-ofm.routes";
import { PdfExtractorIcmsRoutes } from "@/pages/tax/pdfextractor-icms/pdfextractor.icms.routes";
import { SpedDevolutionRoutes } from "@/pages/tax/sped-devolution/sped.devolution.routes";
import SpedRoutes from "@/pages/tax/sped/sped.routes";
import SupplierTaxRoutes from "@/pages/tax/supplier/supplier-tax";
import TaxHistoryRoutes from "@/pages/tax/tax-history/tax-history";
import TaxWorkflow from "@/pages/tax/tax-workflow";
import { FaBalanceScale, FaClipboardCheck } from "react-icons/fa";
import { GoHistory } from "react-icons/go";
import { GrDocumentConfig, GrOracle } from "react-icons/gr";
import { LuCalendarClock, LuClipboardList, LuFileOutput } from "react-icons/lu";
import { MdDashboard } from "react-icons/md";
import { createRoute } from "../createRoute";
import { PATH_IDS } from "../path-ids";
export const taxRoutes = [

  {
    id: "Guias Fiscais",
    category: "GNRE e NFF",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    requiredAction: [],
    groupRequired: [GroupsEnum.FISCAL],
    path: "/workflow/*",
    pathId: "/fiscal",
    isNew: true,
    element: <TaxWorkflow />,
    icon: <LuClipboardList className="h-[20px] w-[20px]" />,
  },
  createRoute({
    id: "Importação Arquivo Sped",
    category: "Sped",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FISCAL],
    path: "/sped/*",
    pathId: PATH_IDS.FISCAL,
    element: <SpedRoutes />,
    Icon: LuClipboardList,
  }),
  createRoute({
    id: "Extração PDF de Notas Fiscais",
    category: "Extração",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    requiredAction: [],
    groupRequired: [GroupsEnum.FISCAL],
    path: "/extracao-pdf-icms/*",
    pathId: "/fiscal",
    element: <PdfExtractorIcmsRoutes />,
    Icon: LuClipboardList,
  }),
  createRoute({
    id: "Importação Arquivo Sped Devolução",
    category: "Sped",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FISCAL],
    path: "/sped/devolution/*",
    pathId: PATH_IDS.FISCAL,
    element: <SpedDevolutionRoutes />,
    Icon: FaClipboardCheck,
  }),
  createRoute({
    id: "Extração Relatorio de Notas Fiscais",
    category: "Relatórios",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    requiredAction: [],
    groupRequired: [GroupsEnum.FISCAL],
    path: "/extracao-nf/*",
    pathId: "/fiscal",
    element: <ExtracaoRoutes />,
    Icon: LuClipboardList,
  }),
  createRoute({
    id: "NCM",
    category: "Configuração de Impostos",
    requiredRole: [RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FISCAL],
    path: "/ncm/*",
    pathId: PATH_IDS.FISCAL,
    element: <ConfigTaxRoutes />,
    Icon: GrDocumentConfig,
  }),
  createRoute({
    id: "Histórico de Solicitações",
    category: "Configuração de Impostos",
    requiredRole: [RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FISCAL],
    path: "/historico-de-solicitacoes/*",
    pathId: PATH_IDS.FISCAL,
    element: <TaxHistoryRoutes />,
    Icon: GoHistory,
  }),
  createRoute({
    id: "Fornecedores",
    category: "Configuração de Impostos",
    requiredRole: [RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FISCAL],
    path: "/fornecedores/*",
    pathId: PATH_IDS.FISCAL,
    element: <SupplierTaxRoutes />,
    Icon: GrOracle,
  }),
  createRoute({
    id: "Dashboard Motor Fiscal",
    category: "Motor Fiscal",
    requiredRole: [RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FISCAL],
    path: "/dashboard-motor-fiscal/*",
    pathId: PATH_IDS.FISCAL,
    element: <EngineDashboard />,
    Icon: MdDashboard,
  }),
  createRoute({
    id: "Aliquotas Base",
    category: "Motor Fiscal",
    requiredRole: [RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FISCAL],
    path: "/aliquotas-base/*",
    pathId: PATH_IDS.FISCAL,
    element: <CalculationBasisRoutes />,
    Icon: FaBalanceScale,
  }),
  createRoute({
    id: "Configuração de Exceção",
    category: "Motor Fiscal",
    requiredRole: [RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FISCAL],
    path: "/excecao-de-tributos/*",
    pathId: PATH_IDS.FISCAL,
    element: <ExceptionTaxRoutes />,
    Icon: GrDocumentConfig,
  }),
  createRoute({
    id: "Histórico Motor Fiscal",
    category: "Motor Fiscal",
    requiredRole: [RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FISCAL],
    path: "/historico-motor-fiscal/*",
    pathId: PATH_IDS.FISCAL,
    element: <EngineHistoryRoutes />,
    Icon: GoHistory,
  }),
  createRoute({
    id: "Extração Fiscal",
    category: "Extração",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FISCAL],
    path: "/closing/*",
    pathId: "/tax",
    element: <TaxClosingRoutes />,
    Icon: LuFileOutput,
  }),
  createRoute({
    id: "Controle de Meses Fiscais",
    category: "Extração",
    requiredRole: [RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.TI, GroupsEnum.FISCAL],
    path: "/closing/periods/*",
    pathId: "/tax",
    element: <PeriodGateRoutes />,
    Icon: LuCalendarClock,
  }),
];
